import React from 'react';
import PageSection from 'components/PageSection';
import { useAPI } from 'api';
import PropEditor from 'components/PropEditor';
import RawJsonDisplay from 'components/RawJsonDisplay';
import { FirewallPolicySettings, FirewallPolicy } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

export default function WorkspacePolicySettings() {
	const api = useAPI();

	const ctx = useOrgContext();

	const [workspaceFirewallPolicySettings, setWorkspaceFirewallPolicySettings] = React.useState<FirewallPolicySettings>({
		policyTemplate: null,
		policyInsertAbove: null
	});

	const [availableFirewallPolicies, setAvailableFirewallPolicies] = React.useState<FirewallPolicy[]>([]);

	const loadWorkspaceFirewallPolicySettings = () => {
		api.get<FirewallPolicySettings>(`${ctx?.apiBaseWorkspace}/overrides/firewall/settings`)
		.then(json => setWorkspaceFirewallPolicySettings(json));
	};

	const saveWorkspaceFirewallPolicySettings = () => {
		api.post(`${ctx?.apiBaseWorkspace}/overrides/firewall/settings`, workspaceFirewallPolicySettings)
		.then(() => loadWorkspaceFirewallPolicySettings());
	};

	const loadFirewallPolicies = () => {
		api.get<FirewallPolicy[]>(`${ctx?.apiBaseWorkspace}/overrides/firewall/policies`)
		.then(json => setAvailableFirewallPolicies(json));
	};

	React.useEffect(() => {
		loadFirewallPolicies();
		loadWorkspaceFirewallPolicySettings();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<PageSection level={3} title="Policies">
				<PropEditor<FirewallPolicySettings>
					object={workspaceFirewallPolicySettings}
					props={[
						{ label: 'Template Policy', key: 'policyTemplate', type: 'select', options: [{ value: '', label: '(none)'}].concat(availableFirewallPolicies.map(policy => ({ label: policy.name, value: policy.id }))) },
						{ label: 'Insert Above Policy', key: 'policyInsertAbove', type: 'select', options: [{ value: '', label: '(none)'}].concat(availableFirewallPolicies.map(policy => ({ label: policy.name, value: policy.id }))) }
					]}
					onChange={setWorkspaceFirewallPolicySettings}
				/>

				<p>
					<button onClick={saveWorkspaceFirewallPolicySettings}>Save Policies</button>
				</p>
			</PageSection>

			<PageSection level={4} title="Raw Data">
				<RawJsonDisplay data={workspaceFirewallPolicySettings} />
			</PageSection>
		</div>
	);
}
